const ko = {
  agency: "몽골 경찰청",
  agencySub: "ЦАГДААГИЙН ЕРӨНХИЙ ГАЗАР",
  system: "마약범죄 수사 통합 플랫폼",
  searchPlaceholder: "사건번호, 대상자, 증거물 검색",
  userName: "Б.Ганзориг 수사관",
  userOrg: "마약범죄수사국 2팀",
  notif: "알림",
  logout: "로그아웃",
  // 대시보드
  dashTitle: "수사 현황 대시보드",
  dashSub: "마약범죄수사국 — 2026년 상반기 기준",
  kpiActiveCases: "진행 중 사건",
  kpiArrests: "검거 인원",
  kpiSeizure: "압수 총량",
  kpiPending: "감정 대기",
  kpiVsPrev: "전분기 대비",
  trendTitle: "월별 사건 접수·검거 추이",
  trendCases: "접수",
  trendArrests: "검거",
  byTypeTitle: "마약 유형별 압수량",
  byTypeUnit: "(g 환산)",
  statusTitle: "사건 처리 상태",
  statusOngoing: "수사중",
  statusProsecuted: "송치",
  statusClosed: "종결",
  regionTitle: "지역별 발생 분포",
  recentTitle: "최근 접수 사건",
  quickActions: "빠른 작업",
  qaNewCase: "사건 등록",
  qaNewEvidence: "증거물 등록",
  qaRequest: "감정 의뢰",
  qaReport: "보고서 작성",
  alertsTitle: "확인 필요",
  cases: "건",
  persons: "명",
  thisMonth: "이번 달",
  viewCase: "사건 보기",
  mDashboard: "대시보드",
  geoTitle: "지리 분석",
  geoSub: "울란바토르 구별 마약범죄 발생 분포",
  viewMarkers: "마커",
  viewHeatmap: "히트맵",
  geoFilterSubstance: "마약 유형",
  hotspotRank: "핫스팟 순위",
  incidents: "발생 건수",
  topSubstance: "주요 마약",
  selectedRegion: "선택 지역",
  regionIncidents: "누적 발생",
  regionActive: "진행 사건",
  regionArrest: "검거 인원",
  legendDensity: "발생 밀도",
  densityLow: "낮음",
  densityHigh: "높음",
  routeTitle: "주요 유입 경로",
  routeSub: "국경 → 수도권 반입 추정 경로",
  geoUpdated: "최근 90일 누적",
  clickRegionHint: "구역을 클릭하면 상세 통계가 표시됩니다",
  frTitle: "포렌식 의뢰",
  frSub: "마약·디지털·생체 등 감정 의뢰 현황",
  frNo: "의뢰번호",
  frDevice: "대상 기기",
  frTarget: "감정 대상",
  frField: "감정 분야",
  frResults: "감정 결과 요약",
  catDrugF: "마약 감정",
  catDigitalF: "디지털",
  catDnaF: "생체/DNA",
  catPrintF: "지문",
  catDocF: "문서·필적",
  catToxF: "약독물",
  ftDrugQual: "마약 정성분석",
  ftDrugQuant: "마약 정량분석",
  ftUnknown: "미상물질 감정",
  ftDna: "DNA 감정",
  ftFingerprint: "지문 감정",
  ftTox: "약독물 분석",
  ftDoc: "문서·필적 감정",
  frType: "분석 유형",
  frRequester: "의뢰자",
  frAnalyst: "분석관",
  frPriority: "우선순위",
  frDate: "의뢰일",
  frProgress: "분석 진행률",
  frArtifacts: "추출 산출물",
  frStepsTitle: "분석 진행 이력",
  newRequest: "의뢰 등록",
  ftExtract: "데이터 추출",
  ftCalls: "통화내역",
  ftMessages: "메시지 복원",
  ftLocation: "위치이력",
  ftRecovery: "삭제파일 복구",
  fsReceived: "접수",
  fsAnalyzing: "분석중",
  fsDone: "완료",
  fsHold: "보류",
  priHigh: "긴급",
  priNormal: "일반",
  frTotal: "전체 의뢰",
  frAnalyzingC: "분석중",
  frDoneC: "완료",
  frHoldC: "보류",
  rpTitle: "분석 보고서",
  rpSub: "디지털 포렌식 분석 결과 보고서",
  rpNo: "보고서번호",
  rpAuthor: "작성자",
  rpDate: "작성일",
  rpSecurity: "보안등급",
  rpTool: "분석 도구",
  rpOverview: "분석 개요",
  rpFindings: "주요 발견사항",
  rpExtracted: "추출 데이터 요약",
  rpCommFreq: "연락 빈도 분석",
  rpConclusion: "결론",
  rpContact: "연락 대상",
  rpTimes: "회",
  rpApproved: "승인완료",
  rpReview: "검토중",
  rpDraft: "초안",
  sevHigh: "중요",
  sevMid: "주의",
  sevInfo: "참고",
  downloadPdf: "PDF 다운로드",
  reportList: "보고서 목록",
  mAudit: "감사로그",
  rolesTitle: "역할/권한 관리",
  rolesSub: "사용자 역할별 기능 접근 권한 설정",
  addRole: "역할 추가",
  roleMembers: "소속 인원",
  permMatrix: "기능별 권한",
  permModule: "메뉴 / 기능",
  permView: "조회",
  permCreate: "등록",
  permEdit: "수정",
  permDelete: "삭제",
  permApprove: "승인",
  permExport: "다운로드",
  modCase: "사건 관리",
  modEvidence: "증거물",
  modDrug: "마약 데이터",
  modAnalysis: "분석",
  modForensic: "포렌식",
  modStats: "통계/보고",
  modSystem: "시스템 관리",
  grantedCount: "허용 권한",
  auditTitle: "감사 로그",
  auditSub: "시스템 사용자 활동 기록",
  colTime: "일시",
  colUser: "사용자",
  colAction: "행위",
  colTarget: "대상",
  colModule: "메뉴",
  colIp: "IP 주소",
  colResult: "결과",
  actLogin: "로그인",
  actLogout: "로그아웃",
  actView: "조회",
  actCreate: "등록",
  actEdit: "수정",
  actDelete: "삭제",
  actExport: "다운로드",
  actPerm: "권한 변경",
  resOk: "성공",
  resFail: "실패",
  resDenied: "권한없음",
  filterUser: "사용자",
  filterAction: "행위",
  filterResult: "결과",
  auditTotal: "총 로그",
  auditToday: "오늘",
  auditDenied: "권한거부",
  auditFail: "실패",
  mInvest: "수사 관리",
  mDrugData: "마약 데이터",
  mAnalysis: "분석",
  mForensic: "포렌식",
  mAgency: "기관 연계",
  mStats: "통계/보고",
  mSupport: "업무지원",
  mSystem: "시스템 관리",
  mMyInfo: "내 정보",
  mCase: "사건 관리",
  mSubject: "대상자 관리",
  mEvidence: "증거물 관리",
  mRequest: "의뢰 관리",
  mSubstance: "마약 물질 데이터",
  mSpectrum: "스펙트럼 레퍼런스",
  mFieldData: "현장 분석 데이터",
  mDataset: "학습 데이터셋",
  mModel: "모델 관리",
  mRelation: "관계 분석",
  mGeo: "지리 분석",
  mStatAnalysis: "통계 분석",
  mForensicReq: "포렌식 의뢰",
  mDigitalEvidence: "디지털 증거물",
  mReport: "분석 보고서",
  mOtherAgency: "타기관 정보",
  mMigration: "기존 데이터 이관",
  mInvStats: "수사 통계",
  mReports: "보고서",
  home: "홈",
  list: "목록",
  detail: "상세",
  search: "검색",
  reset: "초기화",
  register: "등록",
  edit: "수정",
  print: "출력",
  excel: "엑셀 다운로드",
  save: "저장",
  approve: "승인 요청",
  total: "전체",
  items: "건",
  viewAll: "전체보기",
  select: "선택",
  actions: "관리",
  period: "기간",
  status: "상태",
  type: "유형",
  all: "전체",
  name: "성명",
  page: "페이지",
  lastUpdated: "최종 수정",
  demoNote: "본 화면은 제안용 데모이며 모든 데이터는 가상입니다",
  caseDetailTitle: "사건 상세",
  caseNo: "사건번호",
  caseName: "사건명",
  caseStatusActive: "수사중",
  tabBasic: "기본정보",
  tabDrugCard: "마약카드",
  tabPersons: "관련인물",
  tabEvidence: "증거",
  caseType: "사건 유형",
  caseTypeVal: "마약류 유통·판매",
  receivedDate: "접수일자",
  occurredDate: "발생일자",
  occurredPlace: "발생장소",
  jurisdiction: "관할",
  assignedTeam: "담당 부서",
  leadInvestigator: "주임 수사관",
  coInvestigators: "공동 수사관",
  overview: "사건 개요",
  caseOverviewText: "울란바토르 바양주르흐구 일대에서 메스암페타민을 SNS 비밀 채팅방을 통해 판매한 조직적 유통 사건. 국경 반입 경로 추적 중이며, 공범 2명에 대한 추가 수사가 진행 중임.",
  progressHistory: "진행 이력",
  relatedRequests: "연계 의뢰",
  intlCoop: "국제공조",
  intlCoopVal: "UNODC 정보 공유 요청 (진행중)",
  securityLevel: "보안 등급",
  securityLevelVal: "2급 — 수사팀 한정",
  h1: "사건 접수 및 수사 개시",
  h2: "현장 압수수색 — 증거물 12점 확보",
  h3: "피의자 1명 긴급체포",
  h4: "감정 의뢰 — 국립과학수사연구소",
  h5: "관계도 분석 보고서 등록",
  drugCardTitle: "마약카드",
  drugCardNo: "카드번호",
  substanceName: "물질명",
  seizedAmount: "압수량",
  purity: "순도",
  form: "형태",
  formVal: "결정형 (크리스탈)",
  packaging: "포장 상태",
  packagingVal: "지퍼백 소분 24개",
  seizureDate: "압수 일시",
  seizurePlace: "압수 장소",
  analysisStatus: "감정 상태",
  analysisDone: "감정 완료",
  analysisPending: "감정 대기",
  inboundRoute: "반입 경로 (추정)",
  inboundRouteVal: "자민우드 국경 → 울란바토르 (육로)",
  streetValue: "시가 환산",
  distributionMethod: "유통 방식",
  distributionMethodVal: "SNS 비밀 채팅방 — 던지기 수법",
  relatedSubstances: "관련 물질 카드",
  cardCreated: "카드 생성일",
  personRole: "역할",
  personDob: "생년",
  personAddress: "주소지",
  personPhone: "연락처",
  personStatus: "신병 상태",
  roleSuspect: "피의자",
  roleAccomplice: "공범",
  roleVictim: "피해자",
  roleWitness: "참고인",
  custodyArrested: "구속",
  custodyWanted: "지명수배",
  custodyReleased: "불구속",
  custodyInvestigating: "조사중",
  priorRecord: "전과",
  priorYes: "마약류 전과 1회",
  priorNo: "없음",
  viewRelationMap: "관계도 보기",
  evidenceNo: "증거물 번호",
  evidenceName: "품명",
  evidenceCategory: "분류",
  storageLocation: "보관 위치",
  storageStatus: "보관 상태",
  chainOfCustody: "수불 이력",
  catDrug: "마약류",
  catDigital: "디지털기기",
  catCash: "현금/귀중품",
  catOther: "기타",
  stInStorage: "보관중",
  stAnalysis: "감정중",
  stDisposalReq: "폐기 요청",
  stTransferred: "이관",
  registerEvidence: "증거물 등록",
  requestDisposal: "처리 요청",
  evidenceListTitle: "증거물 관리",
  summaryTotal: "전체 증거물",
  summaryInStorage: "보관중",
  summaryAnalysis: "감정중",
  summaryDisposal: "폐기 대기",
  filterCategory: "분류",
  filterStatus: "보관 상태",
  filterCase: "사건번호",
  relatedCase: "연계 사건",
  registeredDate: "등록일",
  registrant: "등록자",
  weight: "중량/수량",
  relationTitle: "관계 분석",
  relationSub: "사건 중심 인물·조직·물질 관계도",
  targetCase: "대상 사건",
  depth: "탐색 단계",
  legend: "범례",
  nodeCase: "사건",
  nodePerson: "인물",
  nodeOrg: "조직",
  nodeSubstance: "마약 물질",
  nodePlace: "장소",
  edgeLabel: "관계",
  selectedNode: "선택 노드",
  connections: "연결",
  addRelation: "관계 추가",
  exportImage: "이미지 저장",
  clickNodeHint: "노드를 클릭하면 상세 정보가 표시됩니다",
  relSell: "판매",
  relSupply: "공급",
  relMember: "조직원",
  relBoss: "총책",
  relBuy: "구매",
  relLocation: "활동지",
  relInvolved: "연루",
  substanceTitle: "마약 물질 데이터",
  substanceListSub: "물질 기준정보 및 스펙트럼 레퍼런스",
  casNo: "CAS 번호",
  classification: "분류",
  scheduleVal: "향정신성의약품 1급",
  aliases: "은어/별칭",
  refSpectra: "기준 스펙트럼",
  fieldSamples: "현장 분석 데이터",
  linkedCases: "연계 사건",
  spectrumViewer: "스펙트럼 뷰어",
  spectrumType: "장비 유형",
  overlayField: "현장 데이터 겹쳐보기",
  matchScore: "유사도",
  refCode: "레퍼런스 코드",
  equipment: "측정 장비",
  measuredDate: "측정일",
  verifyStatus: "검증 상태",
  verified: "검증 완료",
  unverified: "검증 대기",
  wavenumber: "라만 시프트 (cm⁻¹)",
  intensity: "상대 강도",
  riskLevel: "위험 등급",
  riskHigh: "고위험",
  appearance: "성상",
  molFormula: "분자식",
  commonNames: "유통명",
} as const;

export default ko;
